import axios from "axios";
import React, { useEffect } from "react";
import { Input, InputLabel } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import { STANDARD_ERRORS_WAY } from "../../../../../utils/consts";
import { parseAxiosError } from "../../../../../utils/response";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";

import { StyledTwoFaWrapper } from "../../../../elements/twoFa/styledTwoFa";
import DefaultButton from "../../../../styles/materialButtonStyle";
import ValidationFormControl from "../../../../styles/materialValidFormControl";

const ProjectApiRecreateDialog = ({ t, error, projectId, setProjectSecret, setOpen, notification, setNotification }) => {

  const recreateSecret = (event) => {
    event.preventDefault();

    let data = {
      twofa: event.target.twofa.value
    };

    axios.put(`/api/projects/${projectId}/recreate-secret`, data, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProjectSecret("********");
        setNotification({visible: true, type: "success", message: t("details.apiKey.recreateDialog.success")});
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setOpen(false);
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById("twofa").focus();
  }, []);

  return (
    <StyledTwoFaWrapper onSubmit={recreateSecret}>
      <p>{t("details.apiKey.recreateDialog.title")}</p>
      <ValidationFormControl
        error={error.email && true}
        className="twofa-field-group"
      >
        <InputLabel htmlFor="twofa">{t("details.apiKey.recreateDialog.twofaCode")}</InputLabel>
        <Input
          id="twofa"
          required
          type="twofa"
          name="twofa"
          maxLength="6"
          autoComplete="off"
          className="twofa-field-group__input"
        />
        {error.twofa && <FormHelperText id="component-error-text">{error.twofa}</FormHelperText>}
      </ValidationFormControl>
      <div className="twofa-action">
        <DefaultButton
          color="success"
          type="submit"
        >
          {t("details.apiKey.recreateDialog.twofaConfirm")}
        </DefaultButton>
      </div>
    </StyledTwoFaWrapper>
  );
};

export default ProjectApiRecreateDialog;